module.exports={
    "Uplive注册验证": "Uplive登録認証",
    "两次输入的密码必须一致": "パスワードが一致する必要があります",
    "取消": "キャンセル",
    "如验证出现问题，请点击": "認証に問題があります",
    "如验证出现问题，请联系orcalivecs@asiainnovations.com": "もしも認証に問題が発生した場合は、orcalivecs@asiainnovations.comにご連絡ください",
    "如验证出现问题，请联系upcs@asiainnovations.com": "もしも認証に問題が発生した場合は、upcs@asiainnovations.comにご連絡ください",
    "密码修改成功": "パスワード変更に成功しました",
    "密码格式错误": "入力ミス（文字と数字を含め、6-20文字以内で入力してください）",
    "密码由6-20位由数字和字母组成": "パスワードは文字と数字を含め、6-20文字以内で入力してください",
    "恭喜您密码重置成功": "パスワードのリセットに成功しました",
    "恭喜您已成功激活帐户": "あなたのアカウントが作成されました",
    "恭喜您已成功激活账户，赶快返回Uplive中与全球潮人互动吧": "あなたのアカウントがアクティブになりました。Upliveで交流してみましょう！",
    "此链接30分钟内有效，超时请返回应用重新发送": "このリンクは30分まで有効です。過ぎた場合はアプリに戻って再送信してください",
    "知道了": "OK",
    "确认修改": "修正を確認",
    "确认验证": "コード確認",
    "网络连接有误, 请稍后再试": "通信エラーが発生しました。再度お試しください。",
    "联系客服": "カスタマーサポート",
    "请再次输入密码": "パスワード確認",
    "请输入正确的验证码": "正しいコードを入力してください",
    "请返回UpVoice中重新进行邮箱验证": "UpVoiceに戻ってeメールを認証する",
    "请返回Up直播中重新进行邮箱验证": "Upliveに戻ってeメールを認証する",
    "请重新设定登录密码": "パスワードをリセットしてください",
    "请重新设置密码": "パスワードをリセットしてください",
    "赶快返回UpVoice中与全球潮人互动吧": "UpVoiceに戻ります",
    "赶快返回Up直播中与全球潮人互动吧！": "Upliveに戻ります",
    "输入图片中的验证码": "イメージの中のコードを入力",
    "重置密码失败": "パスワードのリセットに失敗しました",
    "验证失败": "コード認証失敗",
    "验证失败，请返回Uplive中重新进行邮箱验证": "コード認証失敗、アプリに戻って改めてメールアドレス認証を行ってください",
    "验证成功": "コード認証成功"
};


// WEBPACK FOOTER //
// ./js/lang/jajp.js